import ImageModal from '../components/ImageModal';
import { useState } from 'react';

export default function About() {
  const [selectedImage, setSelectedImage] = useState<{ url: string; alt: string } | null>(null);

  const openImageModal = (url: string, alt: string) => {
    setSelectedImage({ url, alt });
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };
  return (
    <div className="min-h-screen bg-white">
      {/* 公司介绍 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="section-title">关于我们</h2>
              <div className="space-y-6 text-lg text-secondary-600 leading-relaxed">
                <p>
                  河南艾尔达环保科技有限公司位于郑州市二七区马寨镇工业路11号院6号楼2楼，
                  于2021年6月经郑州市二七区市场监督管理局批准注册成立，是一家具有独立法人资格、
                  专门从事环境检验检测工作的第三方机构。
                </p>
                <p>
                  公司工作环境条件舒适，配备多台套国内一流的检测试验设备，技术力量雄厚。
                  拥有众多专业技术人员，其中中高级职称及同等能力人员占员工总数的40%以上，
                  本科学历90%以上，逐步打造一支国内外专业、权威的环保技术服务团队。
                </p>
                <p>
                  公司拥有独立的第三方检验检测实验室，主要经营业务涵盖挥发性有机物泄漏检测与修复（LDAR）、
                  油气回收、污染源普查、环保核查、建设项目竣工验收、土壤环境污染调查、超低排放评估、
                  环保技术咨询、低碳技术咨询、环境监测物联网建设、智慧环保系统建设等全方位的防控技术和服务。
                </p>
              </div>
            </div>
            <div>
              <img
                src="/images/about-company.png"
                alt="公司介绍"
                className="rounded-lg shadow-lg"
                  onClick={() => openImageModal('/images/about-company.png', '公司介绍')}
              />
            </div>
          </div>
        </div>
      </section>

      {/* 公开声明和承诺 */}
      <section className='py-16 bg-secondary-60'>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
              <h2 className="section-title">公开声明和承诺</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="grid grid-cols-1 md:grid-cols-1 items-center">
              <div>
                <img
                  src="/images/company-secret.png"
                  alt="保密承诺"
                  className="rounded-lg shadow-lg"
                  onClick={() => openImageModal('/images/company-secret.png', '保密承诺')}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 items-center">
              <div>
                <img
                  src="/images/company-commitments.png"
                  alt="公开声明和承诺"
                  className="rounded-lg shadow-lg"
                  onClick={() => openImageModal('/images/company-commitments.png', '公开声明和承诺')}
                />
              </div>
            </div>
          </div>  
        </div>              
      </section>

      {/* 发展历程 */}
      <section className="py-16 bg-secondary-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-title">发展历程</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2021
              </div>
              <h3 className="text-xl font-semibold mb-2">公司成立</h3>
              <p className="text-secondary-600">
                河南艾尔达环保科技有限公司正式成立，开始专注于环保技术服务，同年11月取得检验检测机构资质认定证书（CMA）。
              </p>
            </div>
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2022
              </div>
              <h3 className="text-xl font-semibold mb-2">技术突破</h3>
              <p className="text-secondary-600">
                自主研发LDAR管理平台，获得软件著作权保护。
              </p>
            </div>
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2023
              </div>
              <h3 className="text-xl font-semibold mb-2">体系认证</h3>
              <p className="text-secondary-600">
                获得ISO9001、ISO14001、ISO45001等多项管理体系认证。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 企业文化 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-title">企业文化</h2>
            <p className="section-subtitle">
              以专业、创新、责任为核心价值观
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="card text-center">
              <div className="text-4xl mb-4">🎯</div>
              <h3 className="text-lg font-semibold mb-2">专业</h3>
              <p className="text-secondary-600">
                以专业的技术和服务，为客户提供最优质的环保解决方案
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">💡</div>
              <h3 className="text-lg font-semibold mb-2">创新</h3>
              <p className="text-secondary-600">
                持续技术创新，推动环保技术的发展和进步
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">🌍</div>
              <h3 className="text-lg font-semibold mb-2">责任</h3>
              <p className="text-secondary-600">
                承担环保责任，为保护环境贡献企业力量
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">🤝</div>
              <h3 className="text-lg font-semibold mb-2">合作</h3>
              <p className="text-secondary-600">
                与客户建立长期合作关系，共同实现可持续发展
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 质量方针 */}
      <section className="py-16 bg-primary-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">质量方针</h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-xl mb-8">
              以客户需求为导向，以技术创新为动力，以质量保证为基础，
              为客户提供专业、高效、可靠的环保技术服务。坚持客观公正、科学规范、诚实守信、精益求精。
            </p>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-12">
              <div>
                <h3 className="text-lg font-semibold mb-2">客观公正</h3>
                <p className="text-primary-100">
                  客观公正，不偏不倚，确保检测结果的准确性和公正性
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">科学规范</h3>
                <p className="text-primary-100">
                  科学规范，遵循国家标准和行业规范，确保检测过程的科学性和规范性
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">诚实守信</h3>
                <p className="text-primary-100">
                  诚实守信，不弄虚作假，确保检测结果的真实性和可靠性
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">精益求精</h3>
                <p className="text-primary-100">
                  精益求精，不断提升服务质量和水平，满足客户需求
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ImageModal
        isOpen={!!selectedImage}
        onClose={closeImageModal}
        imageUrl={selectedImage?.url || ''}
        alt={selectedImage?.alt || ''}
      />
    </div>
  )
} 
